import { render, staticRenderFns } from "./gptHole.vue?vue&type=template&id=d18a5dcc&scoped=true"
import script from "./gptHole.vue?vue&type=script&lang=js"
export * from "./gptHole.vue?vue&type=script&lang=js"
import style0 from "./gptHole.vue?vue&type=style&index=0&id=d18a5dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18a5dcc",
  null
  
)

export default component.exports